import PropTypes from "prop-types";
import UsersList from "./UsersList";

// People who shared coins on a post: the same rows as the likes list, with each person's
// "Shared Coins:" and "Comment:" lines (the row renderer lives in UsersList).
export default function CoinsUsersList({ feedActivity = [] }) {
  return <UsersList feedActivity={feedActivity} coins />;
}

CoinsUsersList.propTypes = {
  feedActivity: PropTypes.array,
};
